import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BINDER_SECTIONS } from '../../data/cdaContent';
import { CdaLogo } from '../../components/cda/CdaBrand';
import { useLang } from '../../i18n/cda';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Printer } from 'lucide-react';

const BinderCovers = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Toolbar (hidden when printing) */}
      <div className="print:hidden sticky top-0 z-10 bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between">
        <Button variant="ghost" onClick={() => navigate('/cda/journey')} data-testid="binder-back-button">
          <ArrowLeft className="w-4 h-4 mr-2" /> {t('Back to Journey')}
        </Button>
        <div className="text-sm text-slate-600 hidden sm:block">{t('CDA Professional Portfolio — Section Cover Sheets')}</div>
        <Button onClick={() => window.print()} data-testid="binder-print-button" className="bg-[#0d7d6f] hover:bg-[#0a6358]">
          <Printer className="w-4 h-4 mr-2" /> {t('Print / Save as PDF')}
        </Button>
      </div>

      <div className="max-w-3xl mx-auto p-4 sm:p-8 space-y-6 print:p-0 print:space-y-0">
        <p className="print:hidden text-center text-slate-600 text-sm">
          {t('Print these cover sheets and place one in front of each labeled tab in your 3-inch, 3-ring binder.')}
        </p>
        {BINDER_SECTIONS.map((s, i) => (
          <div
            key={i}
            className="bg-white border border-slate-300 rounded-lg p-12 flex flex-col items-center justify-center text-center aspect-[8.5/11] print:rounded-none print:border-0 print:break-after-page print:min-h-screen"
          >
            <div className="text-xs tracking-[0.3em] uppercase text-[#0d7d6f] font-semibold mb-8">Care Comply • CDA Portfolio</div>
            <div className="w-20 h-1 bg-[#c4622d] mb-10"></div>
            <div className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-3">Tab: {s.tab}</div>
            <h1 className="text-4xl font-bold text-slate-900 mb-6 leading-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {s.title}
            </h1>
            <p className="text-lg text-slate-600 max-w-md">{s.subtitle}</p>
            <div className="w-20 h-1 bg-[#c4622d] mt-10"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BinderCovers;
